import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "../Typography/Typography";

import css from "./RequiredField.module.scss";

export const RequiredField: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={css.wrapper}>
      <Typography size="small">{t("requiredField")}</Typography>
    </div>
  );
};
